var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-market"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 15.6404C3 15.3151 3.30569 15.0764 3.62127 15.1553L6.62127 15.9053C6.84385 15.961 7 16.161 7 16.3904V20.5C7 20.7761 6.77614 21 6.5 21H3.5C3.22386 21 3 20.7761 3 20.5V15.6404Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 14.309C10 14.1196 10.107 13.9465 10.2764 13.8618L13.2764 12.3618C13.6088 12.1956 14 12.4373 14 12.809V20.5C14 20.7761 13.7761 21 13.5 21H10.5C10.2239 21 10 20.7761 10 20.5V14.309Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17 10.309C17 10.1196 17.107 9.9465 17.2764 9.8618L20.2764 8.3618C20.6088 8.19558 21 8.43733 21 8.80902V20.5C21 20.7761 20.7761 21 20.5 21H17.5C17.2239 21 17 20.7761 17 20.5V10.309Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3 10.875L6.8 12L22 3H17.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarket);
export default __webpack_public_path__ + "static/media/market.95b79fbd3621532c189d8e9f95f1e197.svg";
export { ForwardRef as ReactComponent };